<template>
  <div
    class="bg-skin-secondary course-card rounded-xl roboto shadow-card relative"
    :class="[
      responsive == true
        ? [
            '1xl:mb-0',
            '1xl:w-card_large',
            '1xl:h-card_large',
            '1xl:rounded-tl-xl 1xl:rounded-tr-xl',
            '1xl:grid',
            '1xl:grid-cols-coursecard_desktop',
            '1xl:pb-0',
          ]
        : [''],
      explore_card == true
        ? ['1xl:w-card_medium', ' rounded-tr-xl', 'rounded-tl-xl']
        : '',
    ]"
  >
    <div class="absolute flex">
      <div
        v-if="destacate == 'true'"
        class="statuscourse popular"
        :style="`${free == '1' ? 'left: 90px !important;' : ''}`"
      >
        <p class="text-center">+ Vendido</p>
      </div>

      <div v-if="free == '1'" class="statuscourse free">
        <p class="text-center">Gratis</p>
      </div>
    </div>

    <img
      class="
        object-center object-cover
        w-full
        h-explore_card_img_mobile
        rounded-t-xl
        mb-xs
      "
      :class="[
        responsive == true
          ? [
              '1xl:w-183',
              '1xl:h-card_large',
              '1xl:rounded-tl-xl',
              '1xl:rounded-bl-xl',
              ' 1xl:rounded-tr-none	',
              ' 1xl:mb-0	',
            ]
          : '',
        explore_card
          ? ['explore_card_img_mobile', '1xl:h-explore_card_img']
          : [''],
      ]"
      :src="image"
      @error="
        explore_card
          ? ($event.target.src = '/image/resource/default.webp')
          : ($event.target.src = '/image/resource/default_large.webp')
      "
      alt=""
    />

    <div :class="[responsive == true ? ['1xl:py-10px'] : '']">
      <p
        class="card-padding font-bold text-skin-primary text-m nowrapname mt-1"
        :class="[
          responsive == true ? ['1xl:p-0', '1xl:font-normal', '1xl:mt-0'] : '',
          explore_card ? ['mb-9'] : '',
        ]"
      >
        {{ name }}
      </p>

      <p
        v-if="owner_name || owner_lname"
        class="mt-3.5 card-padding font-bold text-m mb-21px "
        :class="[
          responsive == true
            ? ['1xl:p-0', '1xl:mb-s', 'text-skin-secondary']
            : '',
          explore_card ? ['text-skin-title', 'mb-xs', 'mt-0'] : [''],
        ]"
      >
        Curso de {{ owner_name }} {{ owner_lname }}
      </p>

      <p
        v-if="explore_card"
        class="
          text-m text-skin-description
          card-padding
          leading-18
          roboto
          pb-10px
          nowrapdescription
        "
        v-html="description"
      ></p>

      <div
        v-if="!explore_card"
        class="
          progressbar
          w-progressbar_mobile
          bg-skin-porgressbar
          grid
          mb-s
          ml-15
          1xl:ml-0
        "
        :class="[responsive == true ? [' 1xl:w-progressbar_desktop'] : '']"
      ></div>

      <p
        v-if="!explore_card"
        class="card-padding text-m text-skin-tertiary mb-xs"
        :class="responsive == true ? [' 1xl:hidden'] : ''"
      >
        0% completado
      </p>

      <ThumbsUp
        @click="openQualify"
        v-if="responsive"
        class="ml-20 cursor-pointer mb-xs 1xl:hidden"
        fill="#848484"
        stroke="#848484"
      />

      <Rating
        v-if="!explore_card"
        class="block mb-20 card-padding"
        :class="responsive == true ? [' 1xl:hidden'] : ''"
      />

      <div
        class="hidden grid-cols-3fr mb-20 pr-40"
        :class="responsive == true ? [' 1xl:grid'] : ''"
      >
        <p class="text-m text-skin-tertiary">0% completado</p>
        <ThumbsUp
          @click="openQualify"
          v-if="responsive"
          class="ml-20 cursor-pointer mb-xs"
          fill="#848484"
          stroke="#848484"
        />
        <Rating class="justify-self-end" />
      </div>

      <div class="flex flex-justify-between mt-3 mb-1" v-if="explore_card">
        <section class="flex flex-col justify-center w-full px-3 items-center">
          <div
            class="flex justify-between items-center w-full px-4 mb-2"
            v-if="explore_card"
          >
            <p
              class="text-skin-pink text-big font-bold"
              v-text="`$ ${parse_price}`"
              v-if="parse === true && parse_price != ''"
            />

            <p
              class="text-skin-pink text-big font-bold"
              v-else-if="price"
              v-text="`$ ${price}`"
            />

            <div class="flex items-center">
              <User fill="#848484" stroke="#848484" />

              <span
                class="text-s text-skin-description"
                v-text="users_in_course"
              />
            </div>
          </div>

          <Button
            py="s"
            @click="goToCourse"
            :text="'Ver información'"
            text_color="white"
          />
        </section>
      </div>

      <span
        class="card-padding"
        :class="[
          responsive == true ? ['1xl:p-0'] : '',
          explore_card == true ? ['mb-25'] : '',
        ]"
        v-else
      >
        <Button
          py="s"
          @click="goToCourse"
          :text="'Empezar curso'"
          text_color="white"
        />
      </span>
    </div>
  </div>
</template>

<script>
import User from "../components/icons/User.vue";
import ThumbsUp from "../components/icons/ThumbsUp.vue";
import Button from "../components/Button.vue";
import StatusCourse from "../components/StatusCourse.vue";
import Rating from "./Rating.vue";
export default {
  components: {
    Button,
    User,
    ThumbsUp,
    StatusCourse,
    Rating,
  },
  props: {
    responsive: {
      default: false,
      type: Boolean,
    },
    explore_card: {
      default: false,
      type: Boolean,
    },
    parse: {
      default: false,
      type: Boolean,
    },
    destacate: {
      type: String,
    },
    free: {
      default: null,
    },
    image: {
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    description: {
      type: String,
    },
    price: {
      type: String,
    },
    owner_name: {
      type: String,
    },
    owner_lname: {
      type: String,
    },
    parse_data: {
      type: String,
    },
    users_in_course: {
      type: Number,
    },
    course: {
      type: Object,
    },
    source_id: {
      default: "",
    },
  },
  data() {
    return {
      course_price: "",
      parse_img: "",
      parse_price: "",
      currentPage: 1,
    };
  },
  mounted() {},
  methods: {
    openQualify() {
      this.$store.commit("openqualify", true);
    },
    goToCourse() {
      console.log(this.course)
      this.$router.push({ 
        name: "Detail", 
        params: { 
          slug: this.course.courses.name.toLowerCase().replace(/ /g,'-').replace(/[^\w-]+/g,''),
        },
        query: {course: this.course.id}
      });

    },
  },
};
</script>

<style scoped>
.nowrapname {
  max-width: 380px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.nowrapdescription {
  max-width: 275px;
  max-height: 69px;
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  /* text-align: justify; */
  -webkit-box-orient: vertical;
}
</style>
